// API Endpoints Configuration
// Centralized location for all API endpoints to maintain consistency

export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ME: '/auth/me',
    UPDATE_ME: '/auth/me', // PATCH
    REFRESH: '/auth/refresh',
    SESSION: '/auth/session',
    USERS: '/auth/users',
    UPDATE_USER: (username) => `/auth/users/${username}`, // PATCH
    APPROVE: (username) => `/auth/approve/${username}`,
  },

  // Prepared PDB Files (Structures)
  PREPS: {
    BASE: '/preps',
    BY_ID: (id) => `/preps/${id}`,
  },

  // Clusters
  CLUSTERS: {
    BASE: '/clusters',
    BY_ID: (id) => `/clusters/${id}`,
  },

  // Cluster Specs
  CLUSTERSPECS: {
    BASE: '/clusterspecs',
    BY_ID: (id) => `/clusterspecs/${id}`,
  },

  // Pocket Specs
  POCKETSPECS: {
    BASE: '/pocketspecs',
    BY_ID: (id) => `/pocketspecs/${id}`,
  },

  // Input Specs
  INPUTSPECS: {
    BASE: '/inputspecs',
    BY_ID: (id) => `/inputspecs/${id}`,
    YAML: (id) => `/inputspecs/${id}/yaml`,
  },

  // Groups
  GROUPS: {
    BASE: '/groups',
    BY_ID: (id) => `/groups/${id}`,
  },

  // Entries
  ENTRIES: {
    BASE: '/entries',
    BY_ID: (id) => `/entries/${id}`,
    DOWNLOAD_ZIP: '/entries/download_zip',
  },
};